import styled from "@emotion/styled";
import { Flex, Input } from "antd";
import React from "react";
import { Controller } from "react-hook-form";
import { ErrorMessage, SuccessMessage } from "./TextInput";
import runes from "runes2";
const { TextArea } = Input;

const Container = styled.div(() => ({
  flex: 1,
}));

const CustomTextArea = ({
  name,
  control,
  label,
  id,
  labelafter,
  placeholder,
  maxLength,
  customMessage,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        return (
          <Container>
            <Flex justify="space-between">
              <label htmlFor={id}>{label}</label>

              {labelafter}
            </Flex>

            <TextArea
              style={{ resize: "none" }}
              count={{
                show: true,
                max: 100,
                strategy: txt => runes(txt).length,
                exceedFormatter: (txt, { max }) =>
                  runes(txt).slice(0, max).join(""),
              }}
              {...field}
              id={id}
              rows={4}
              size="large"
              placeholder={placeholder}
              status={errors[name] ? "error" : ""}
              name={name}
              maxLength={maxLength}
            />

            {customMessage ? (
              <SuccessMessage>{customMessage}</SuccessMessage>
            ) : (
              <ErrorMessage>
                {errors[name]?.message || errors[`${name}_checked`]?.message}
              </ErrorMessage>
            )}
          </Container>
        );
      }}
    />
  );
};

export default CustomTextArea;
